import axios from 'axios';
import { useCallback } from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import { API_REQUEST_URL } from '../../../common/apiConfig';
import {
  DASHBOARD_FETCH_EXPANDED_UNDER_MIN_DETAILS_BEGIN,
  DASHBOARD_FETCH_EXPANDED_UNDER_MIN_DETAILS_SUCCESS,
  DASHBOARD_FETCH_EXPANDED_UNDER_MIN_DETAILS_FAILURE,
  DASHBOARD_FETCH_EXPANDED_UNDER_MIN_DETAILS_DISMISS_ERROR,
  ERROR_CONTACT_ADMIN,
} from './constants';

const normalizeDeliveryDateToYYYYMMDD = value => {
  if (value === null || value === undefined) return value;
  const str = String(value).trim();
  // already YYYYMMDD
  if (/^\d{8}$/.test(str)) return str;
  // convert YYYY-MM-DD -> YYYYMMDD
  if (/^\d{4}-\d{2}-\d{2}$/.test(str)) return str.replace(/-/g, '');
  // keep anything else unchanged to avoid side effects
  return value;
};

export function fetchExpandedUnderMinDetails(payload = {}) {
  return (dispatch, getState) => {
    dispatch({
      type: DASHBOARD_FETCH_EXPANDED_UNDER_MIN_DETAILS_BEGIN,
    });

    const promise = new Promise((resolve, reject) => {
      const cognitoIdToken = getState().home.auth.cognitoIdToken;
      const token = `Bearer ${cognitoIdToken}`;
     
      // const doRequest = axios.post(`${API_REQUEST_URL}/getExpandedUnderMinDetails`, payload, {
      //   headers: {
      //     Authorization: token,
      //   },
      // });

      const requestPayload = {
        ...payload,
        ...(payload.deliveryDate !== undefined &&
          payload.deliveryDate !== null && {
          deliveryDate: normalizeDeliveryDateToYYYYMMDD(payload.deliveryDate),
        }),
      };

      const doRequest = axios.post(
        `${API_REQUEST_URL}/getExpandedUnderMinDetails`,
        requestPayload,
        {
          headers: {
            Authorization: token,
          },
        },
      );

      doRequest.then(
        res => {
          const data = res.data;
          dispatch({
            type: DASHBOARD_FETCH_EXPANDED_UNDER_MIN_DETAILS_SUCCESS,
            data: data,
          });
          resolve(data);
        },
        err => {
          const errorMsg = err && err.response ? err.response.data.message : ERROR_CONTACT_ADMIN;
          dispatch({
            type: DASHBOARD_FETCH_EXPANDED_UNDER_MIN_DETAILS_FAILURE,
            data: { error: errorMsg },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissFetchExpandedUnderMinDetailsError() {
  return {
    type: DASHBOARD_FETCH_EXPANDED_UNDER_MIN_DETAILS_DISMISS_ERROR,
  };
}

export function useFetchExpandedUnderMinDetails() {
  const dispatch = useDispatch();

  const {
    expandedUnderMinDetails,
    fetchExpandedUnderMinDetailsPending,
    fetchExpandedUnderMinDetailsError,
  } = useSelector(
    state => ({
      expandedUnderMinDetails: state.dashboard.expandedUnderMinDetails,
      fetchExpandedUnderMinDetailsPending: state.dashboard.fetchExpandedUnderMinDetailsPending,
      fetchExpandedUnderMinDetailsError: state.dashboard.fetchExpandedUnderMinDetailsError,
    }),
    shallowEqual,
  );

  const boundAction = useCallback((...args) => {
    return dispatch(fetchExpandedUnderMinDetails(...args));
  }, [dispatch]);

  const boundDismissError = useCallback(() => {
    return dispatch(dismissFetchExpandedUnderMinDetailsError());
  }, [dispatch]);

  return {
    expandedUnderMinDetails,
    fetchExpandedUnderMinDetails: boundAction,
    fetchExpandedUnderMinDetailsPending,
    fetchExpandedUnderMinDetailsError,
    dismissFetchExpandedUnderMinDetailsError: boundDismissError,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case DASHBOARD_FETCH_EXPANDED_UNDER_MIN_DETAILS_BEGIN:
      return {
        ...state,
        fetchExpandedUnderMinDetailsPending: true,
        fetchExpandedUnderMinDetailsError: null,
      };

    case DASHBOARD_FETCH_EXPANDED_UNDER_MIN_DETAILS_SUCCESS:
      return {
        ...state,
        expandedUnderMinDetails: action.data,
        fetchExpandedUnderMinDetailsPending: false,
        fetchExpandedUnderMinDetailsError: null,
      };

    case DASHBOARD_FETCH_EXPANDED_UNDER_MIN_DETAILS_FAILURE:
      return {
        ...state,
        fetchExpandedUnderMinDetailsPending: false,
        fetchExpandedUnderMinDetailsError: action.data.error,
      };

    case DASHBOARD_FETCH_EXPANDED_UNDER_MIN_DETAILS_DISMISS_ERROR:
      return {
        ...state,
        fetchExpandedUnderMinDetailsError: null,
      };

    default:
      return state;
  }
}


